import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { loadConfig } from './config.js';
import './index.css';
import { AuthProvider } from "./context/AuthContext";

const startApp = async () => {
    await loadConfig();
    
    ReactDOM.createRoot(document.getElementById('root')).render(
        <AuthProvider>
            <App />
        </AuthProvider>
    );
};

startApp();